import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { MaterialService } from '../../../../../../../../../shared/services/material.service';
import { BidItem } from '../../../../../../../../../shared/models/bid-item';
import { Material } from '../../../../../../../../../shared/models/material';

@Component({
    selector: 'app-delivery-tracking-materials-dialog',
    templateUrl: './delivery-tracking-materials-dialog.component.html',
    styleUrls: ['./delivery-tracking-materials-dialog.component.scss'],
    standalone: false
})
export class DeliveryTrackingMaterialsDialogComponent implements OnInit {
  bidItem: BidItem;
  materials: any[] = [];
  changed = false;

  constructor(
    public dialogRef: MatDialogRef<DeliveryTrackingMaterialsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { bidItem: BidItem; materials: Material[]; projectId: string },
    private materialService: MaterialService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.bidItem = this.data.bidItem;
    const bidItemMaterialIds = (this.bidItem.materials || []).map(m => m.id);
    this.materials = this.data.materials.map(m => ({
      ...m,
      checked: bidItemMaterialIds.includes(m.id),
    }));
  }

  async onChange(material: any, checked: boolean): Promise<void> {
    try {
      if (checked) {
        await this.materialService.addBidItem(material, this.bidItem);
      } else {
        await this.materialService.removeBidItem(material, this.bidItem);
      }
      material.checked = checked;
      this.changed = true;
      this.snackBar.open(
        checked ? `Added ${material.name}` : `Removed ${material.name}`,
        '',
        { duration: 2000 },
      );
    } catch {
      this.snackBar.open('Failed to update material association', '', { duration: 3000 });
    }
  }

  close(): void {
    this.dialogRef.close(this.changed);
  }
}
